import { Data } from 'Lib';

const { AppData, DataManager, Enum, GenericTableData, UserData, UserRoleData } =
  Data;

export { AppData, DataManager, Enum, GenericTableData, UserData, UserRoleData };
